import React from "react";

import PropTypes from "prop-types";

import useRbFlexViewStyles from "./useRbFlexViewStyles";

function RbFlexView(props) {
  const { children, direction, ...others } = props;

  const classes = useRbFlexViewStyles(props);

  return (
    <div {...others} className={classes.root}>
      {children}
    </div>
  );
}

RbFlexView.propTypes = {
  children: PropTypes.node,
  direction: PropTypes.string,
};

RbFlexView.defaultProps = {
  children: null,
  direction: "column",
};

export default React.memo(RbFlexView);
